import { BaseService } from './base-service';

class MigrationToolsService extends BaseService {
  /**
   * @description: 校验迁移租户和管理用户
   * @return {*}
   * @author: piaoziyue piaoziyue@qfei.cn
   */
  validateTenantAndUser(data) {
    return this.request({
      method: 'post',
      url: `mig_data/tool/valid_tenant_and_user`,
      data
    });
  }
  /**
   * @description: 获取租户迁移状态
   * @return {*}
   * @author: piaoziyue piaoziyue@qfei.cn
   */
  getTenantStatus(data) {
    return this.request({
      method: 'get',
      url: `/mig_data/tool/get_tenant_export_import_status/${data.tenantId}`
    });
  }
  /**
   * @description: 获取数据列表
   * @return {*}
   * @author: piaoziyue piaoziyue@qfei.cn
   */
  getDataTaskList(data) {
    return this.request({
      method: 'post',
      url: `/mig_data/tool/data_task_list`,
      data
    });
  }
  /**
   * @description: 一键导出
   * @return {*}
   * @author: piaoziyue piaoziyue@qfei.cn
   */
  postOneClickExport(data) {
    return this.request({
      method: 'post',
      url: `/mig_data/tool/one_click_export`,
      data
    });
  }
  /**
   * @description: 重新导出
   * @return {*}
   * @author: piaoziyue piaoziyue@qfei.cn
   */
  postReExport(data) {
    return this.request({
      method: 'post',
      url: `/mig_data/tool/re_export`,
      data
    });
  }
  /**
   * @description: 一键导入
   * @return {*}
   * @author: piaoziyue piaoziyue@qfei.cn
   */
  postOneClickImport(data) {
    return this.request({
      method: 'post',
      url: `/mig_data/tool/one_click_import`,
      data
    });
  }
  /**
   * @description: 重新导入
   * @return {*}
   * @author: piaoziyue piaoziyue@qfei.cn
   */
  postReImport(data) {
    return this.request({
      method: 'post',
      url: `/mig_data/tool/re_import`,
      data
    });
  }
  /**
   * @description: 更新租户导入状态
   * @return {*}
   * @author: piaoziyue piaoziyue@qfei.cn
   */
  postUpdateTenantImportStatus(data) {
    return this.request({
      method: 'post',
      url: `/mig_data/tool/update_tenant_import_status`,
      data
    });
  }

  /**
   * @brief 获取支持模块
   */
  getSupportModules(data) {
    return this.request({
      method: 'GET',
      url: `/mig_data/tool/supplement/type/${data.tenantId}`
      // params: data
    });
  }
  /**
   * @brief 创建任务
   */
  createTask(data) {
    return this.request({
      method: 'POST',
      url: `/mig_data/tool/supplement`,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data
    });
  }
}
// TAG: 迁移工具
export const migrationToolsService = new MigrationToolsService();
